import { useState, useEffect, useRef } from "react";
import { Home } from "lucide-react";
export default function HeroBanner() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "repeat",
    color: "rgb(102, 102, 102)",
    fontFamily: '"Open Sans", Arial, sans-serif',
    animation: "none 0s ease 0s 1 normal none running",
    position: "relative",
    paddingTop: "0px",
    paddingBottom: "0px"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700;800;900&display=swap');

        @keyframes confetti1 {
          0% { transform: rotate(0deg) translateY(0px); opacity: 1; }
          100% { transform: rotate(45deg) translateY(20px); opacity: 0.7; }
        }
        @keyframes confetti2 {
          0% { transform: rotate(15deg) translateY(0px); opacity: 0.9; }
          100% { transform: rotate(-30deg) translateY(15px); opacity: 0.6; }
        }
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .thirty-badge-animate {
          animation: fadeSlideIn 0.9s ease forwards;
        }
        .logo-circle-animate {
          animation: fadeSlideIn 1.1s ease 0.2s forwards;
          opacity: 0;
        }
        .confetti-piece {
          animation: confetti1 2s ease-in-out infinite alternate;
        }
        .confetti-piece2 {
          animation: confetti2 2.5s ease-in-out infinite alternate;
        }
      `}</style>

      <div ref={ref} className="relative w-full overflow-hidden" style={{
      minHeight: "490px"
    }}>
        <picture>
          {/* Mobile Banner - Shows on screens smaller than 768px */}
          <source media="(max-width: 767px)" srcSet="https://ultimate-molly.10web.cloud/wp-content/uploads/2026/06/hf_20260604_111419_bc9cd9e1-6cef-47c2-80be-7978406dc1c7-Large.jpeg" />
          
          {/* Desktop Banner - Shows on desktop and acts as the default fallback */}
          <img src="https://ultimate-molly.10web.cloud/wp-content/uploads/2026/06/bannerleadsweb-Large.jpeg" alt="TheLeads Home Banner" className="w-full h-auto object-cover" loading="lazy" decoding="async" style={{
          display: "block",
          minHeight: "490px",
          objectFit: "cover",
          objectPosition: "center center"
        }} />
        </picture>
        <div className="absolute inset-0 flex items-center" style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }}>
          
        </div>
      </div>
    </section>;
}